import { render, staticRenderFns } from "./ConsultChoosePage.vue?vue&type=template&id=055ac63b"
import script from "./ConsultChoosePage.vue?vue&type=script&lang=ts"
export * from "./ConsultChoosePage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultChoosePage.vue?vue&type=style&index=0&id=055ac63b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports